/**
 * 移除返回HTML的style标签
 * @param html
 * @returns 移除后的html
 */
export function removeHtmlStyle(html) {
  var rel = /<style>[\s\S]*?<\/style>/gi;
  var newHtml = "";
  if (html) {
    newHtml = html.replace(rel, "");
  }
  return newHtml;
}
